import { createSlice } from '@reduxjs/toolkit';

export const AditionalInfo = createSlice({
  name: 'aditionalUserInfo',
  initialState: {
    storeId: '',
    rxId: '',
    piid: '',
  },
  reducers: {
    aditionalUserInfo: (state, action) => {
      state.storeId = action.payload.storeId;
      state.rxId = action.payload.rxId;
    },
    setPiId: (state, action) => {
      state.piid = action.payload || '';
    },
  },
});

export const { aditionalUserInfo, setPiId } = AditionalInfo.actions;

export default AditionalInfo.reducer;
